import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import type { GameLogDto, Winner } from '@mafia/core';
import { api, ApiError } from '@/lib/api';
import { formatDate, teamName } from '@/lib/format';
import { Alert, Badge, Card, PageSpinner } from '@/components/ui';
import { MatchTimeline } from '@/components/MatchTimeline';
import { KindBadge } from '@/components/Kind';
import { ParticipantsTable } from './ParticipantsTable';

export function AdminGameLog() {
  const { id = '' } = useParams();
  const game = useQuery({ queryKey: ['admin', 'game-log', id], queryFn: () => api<GameLogDto>(`/api/admin/games/${id}/log`) });

  if (game.isLoading) return <PageSpinner />;
  if (game.isError) return <Alert>{game.error instanceof ApiError ? game.error.message : 'Не удалось загрузить журнал'}</Alert>;
  const g = game.data!;

  return (
    <div className="space-y-4">
      <Link to="/admin/games" className="inline-flex items-center gap-1 text-sm text-zinc-400 hover:text-white">
        <ArrowLeft className="h-4 w-4" /> Все матчи
      </Link>
      <div>
        <p className="text-sm text-zinc-500">
          {g.roomName ?? 'Комната удалена'} · {formatDate(g.startedAt)} — {formatDate(g.endedAt)}
        </p>
        <h1 className="mt-1 font-display text-2xl">
          {g.status === 'ABORTED' ? 'Игра прервана' : g.winner === 'DRAW' ? 'Ничья' : `Победа: ${g.winner ? teamName[g.winner as Winner] : '—'}`}
        </h1>
        <div className="mt-2 flex gap-2">
          <KindBadge kind={g.kind} showAmateur />
          <Badge>{g.playerCount} игроков</Badge>
          <Badge>{g.daysPlayed} дн.</Badge>
          {g.moderatorNickname && <Badge tone="gold">ведущий: {g.moderatorNickname}</Badge>}
          <Badge>{g.log.length} событий</Badge>
        </div>
      </div>

      <Card className="overflow-hidden">
        <ParticipantsTable participants={g.participants} adminLinks />
      </Card>

      <MatchTimeline game={g} technical />
    </div>
  );
}
